module.exports = __webpack_public_path__ + "media/images/mobile/dummy02-ec09d6c831a7acf6b1a3edfc38a93f22.jpg";